import React, { useRef, useState, useEffect } from 'react'
import styles from './UserInfoManager.module.css'
import classNames from 'classnames'
import {
  Button,
  ConfigProvider,
  Flex,
  Form,
  Input,
  Popconfirm,
  Upload,
  message,
} from 'antd'
import { LeftOutlined } from '@ant-design/icons'
import OSS from 'ali-oss'
import {
  getAliOssTokenRequest,
  getUserInfoRequest,
  updateUserInfoRequest,
} from './api'
import { getSixMathRandom } from '../../../util/handMath'
import { ALI_OSS_PATH } from '../../../util/constants'
import { clearAllCookies } from '../../../util/handleObject'
import locale from 'antd/locale/zh_CN'
import { closeAdminPage, closeSchoolAdminPage, openLogin } from '../../../store/modalsSlice'
import { useDispatch } from 'react-redux'
let client
let clientExpTime
export default function UserInfoManager(props) {
  const dispatch = useDispatch()
  const [userInfo, setUserInfo] = useState({
    user_login: '',
    school_name: '',
  })
  const [avatar, setAvatar] = useState('')
  const [form] = Form.useForm()

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    getUserInfo()
    getAliOssToken()
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function getUserInfo() {
    getUserInfoRequest((data) => {
      if (data.ret == 1) {
        setUserInfo(data.data)
        form.setFieldsValue(data.data)
        setAvatar(data.data.image_url)
      } else if (data.ret == 99) {
        message.warning(data.msg)
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      } else {
        message.warning(data.msg)
      }
    })
  }

  function getAliOssToken() {
    let nowDate = new Date().getTime()
    if (!client || nowDate - clientExpTime > 1200000) {
      clientExpTime = new Date().getTime()
      getAliOssTokenRequest((data) => {
        if ('Credentials' in data) {
          client = new OSS({
            // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
            region: 'oss-cn-qingdao',
            // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
            accessKeyId: data.Credentials.AccessKeyId,
            accessKeySecret: data.Credentials.AccessKeySecret,
            // 从STS服务获取的安全令牌（SecurityToken）。
            stsToken: data.Credentials.SecurityToken,
            refreshSTSToken: async () => {
              // 向您搭建的STS服务获取临时访问凭证。
              getAliOssTokenRequest((data) => {
                return {
                  accessKeyId: data.Credentials.AccessKeyId,
                  accessKeySecret: data.Credentials.AccessKeySecret,
                  stsToken: data.Credentials.SecurityToken,
                }
              })
            },
            // 刷新临时访问凭证的时间间隔，单位为毫秒。
            refreshSTSTokenInterval: 3000000,
            // 填写Bucket名称。
            bucket: 'tgnp',
          })
        }
      })
    }
  }
  function handleChange1(info) {
    getAliOssToken()
    let tempList = info.fileList.map((item, index) => {
      let tempDic = {
        url: item.url,
        uid: item.uid,
        status: item.status,
        name: item.name,
      }
      return tempDic
    })
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`)
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  const customRequest = async (options) => {
    const { onSuccess, onError, file } = options

    try {
      // 使用阿里云OSS SDK上传文件
      let timestamp = new Date().getTime()
      let random = getSixMathRandom()
      const result = await client.put(
        ALI_OSS_PATH + 'user/' + timestamp + random + file.name,
        file,
      )
      file.url = result.url.replace('http:', 'https:')
      onSuccess(file)
      changeImgMethod(file.url)
    } catch (e) {
      message.error(`头像上传失败`)
      onError(e)
    }
  }

  function changeImgMethod(url) {
    form.setFieldValue('image_url', url)
    setAvatar(url)
  }
  function onFinish(values) {
    console.log('----------------------')
    console.log(values)
    updateUserInfoRequest(values.image_url, values.name, values.pwd, (data) => {
      console.log(data)
      if (data.ret == 1) {
        props.changeUserName(values.name)
        props.changeUserAvatar(values.image_url)
        setUserInfo({
          ...userInfo,
          name: values.name,
          image_url: values.image_url,
          pwd: values.pwd,
        })
        setAvatar(values.image_url)

        message.success('保存成功')
      } else if (data.ret == 99) {
        message.warning(data.msg)
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      } else {
        message.error(data.msg)
      }
    })
  }

  return (
    <div className={styles.background}>
      <Button
        onClick={() => {
          props.onCancel()
        }}
        icon={<LeftOutlined />}
        type="text"
        style={{
          fontSize: 18,
        }}
      >
        返回
      </Button>
      <div className={styles.infoContainer} style={{ position: 'relative' }}>
        <div className={styles.titleText}>编辑个人信息</div>
        <div className={styles.desText}>完善您的个人资料，以便更好地使用</div>
        <ConfigProvider
          locale={locale}
          theme={{
            token: {
              colorPrimary: '#F5B544',
            },
          }}
        >
          <Popconfirm
            placement="bottom"
            title={''}
            description={'是否退出登录'}
            okText="是"
            cancelText="否"
            onConfirm={(e) => {
              props.onCancel()
              sessionStorage.clear()
              clearAllCookies()
              dispatch(closeSchoolAdminPage())
              dispatch(openLogin())
            }}
          >
            <Button
              type="primary"
              style={{
                top: 10,
                right: 'calc(50% - 430px)',
                position: 'absolute',
              }}
            >
              退出登录
            </Button>
          </Popconfirm>
        </ConfigProvider>
        <div className={styles.editInfoContainer}>
          <ConfigProvider
            locale={locale}
            theme={{
              components: {
                Form: {
                  labelFontSize: 18,
                },
              },
            }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              style={{ marginTop: 50, width: 680, marginBottom: 70 }}
              size="large"
            >
              <Form.Item
                label=""
                name="image_url"
                rules={[{ required: false, message: '请输入应用名称' }]}
                labelAlign="right"
                wrapperCol={{ offset: 10 }}
              >
                <Upload
                  listType="picture"
                  fileList={[]}
                  onChange={handleChange1}
                  customRequest={customRequest}
                  accept=".jpg,.png,.jpeg,.svg"
                >
                  <img
                    className={styles.avatar}
                    src={
                      avatar == null || avatar == 'null' || avatar == ''
                        ? require('../avatar.png')
                        : avatar
                    }
                  ></img>
                  <div className={styles.uploadText}>点击更换头像</div>
                </Upload>
              </Form.Item>

              <Form.Item
                label="姓名"
                name="name"
                rules={[{ required: true, message: '姓名不能为空' }]}
                labelAlign="right"
                style={{ marginTop: 40 }}
              >
                <Input
                  placeholder="请输入姓名1"
                  size="large"
                  // value={name}
                  onChange={(e) => {
                    console.log(e.target.value)
                    // setName(e.target.value)
                  }}
                />
              </Form.Item>

              <Form.Item
                label="账号（手机号）"
                name="user_login"
                rules={[{ required: false, message: '请输入应用名称' }]}
                labelAlign="right"
              >
                {/* <text className={styles.rightText}>{userInfo.user_login}</text> */}
                <Input size="large" value={userInfo.user_login} disabled />
              </Form.Item>

              <Form.Item
                label="密码"
                name="pwd"
                rules={[{ required: true, message: '密码不能为空' }]}
                labelAlign="right"
              >
                <Input.Password
                  placeholder="请输入登录密码"
                  size="large"
                  style={{ backgroundColor: 'white' }}
                />
              </Form.Item>
              {userInfo.school_name != null &&
              userInfo.school_name != '' &&
              userInfo.school_name != 'null' ? (
                <Form.Item
                  label="所属学校"
                  name="school_name"
                  rules={[{ required: false, message: '请输入应用名称' }]}
                  labelAlign="right"
                >
                  {/* <text className={styles.rightText}>
                    {userInfo.school_name}
                  </text> */}
                  <Input size="large" value={userInfo.school_name} disabled />
                </Form.Item>
              ) : null}
              <Form.Item style={{ marginTop: 80 }}>
                <Flex justify="end">
                  <Button
                    htmlType="button"
                    style={{ backgroundColor: 'white', width: 100 }}
                    onClick={() => {
                      form.setFieldsValue(userInfo)
                      setAvatar(userInfo.image_url)
                      props.onCancel()
                    }}
                  >
                    取消
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      marginLeft: 30,
                      width: 100,
                      backgroundColor: '#F7C469',
                    }}
                  >
                    保存修改
                  </Button>
                </Flex>
              </Form.Item>
            </Form>
          </ConfigProvider>
        </div>
      </div>
    </div>
  )
}
